module.exports = __webpack_public_path__ + "img/trophy_inner.d50c3593.png";